import { render, staticRenderFns } from "./CommentSection.vue?vue&type=template&id=3cf80f53&scoped=true"
import script from "./CommentSection.vue?vue&type=script&lang=js"
export * from "./CommentSection.vue?vue&type=script&lang=js"
import style0 from "./CommentSection.vue?vue&type=style&index=0&id=3cf80f53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf80f53",
  null
  
)

export default component.exports